var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4.95833H2.08333C1.61662 4.95833 1.38327 4.95833 1.20501 5.04916C1.04821 5.12906 0.920722 5.25654 0.840828 5.41334C0.75 5.5916 0.75 5.82496 0.75 6.29167V15.2917C0.75 15.7584 0.75 15.9917 0.840828 16.17C0.920722 16.3268 1.04821 16.4543 1.20501 16.5342C1.38327 16.625 1.61662 16.625 2.08333 16.625H5.75M5.75 16.625H10.75M5.75 16.625L5.75 2.95833C5.75 2.49162 5.75 2.25827 5.84083 2.08001C5.92072 1.92321 6.04821 1.79572 6.20501 1.71583C6.38327 1.625 6.61662 1.625 7.08333 1.625L9.41667 1.625C9.88338 1.625 10.1167 1.625 10.295 1.71583C10.4518 1.79572 10.5793 1.92321 10.6592 2.08001C10.75 2.25827 10.75 2.49162 10.75 2.95833V16.625M10.75 8.29167H14.4167C14.8834 8.29167 15.1167 8.29167 15.295 8.38249C15.4518 8.46239 15.5793 8.58987 15.6592 8.74667C15.75 8.92493 15.75 9.15829 15.75 9.625V15.2917C15.75 15.7584 15.75 15.9917 15.6592 16.17C15.5793 16.3268 15.4518 16.4543 15.295 16.5342C15.1167 16.625 14.8834 16.625 14.4167 16.625H10.75",
    stroke: "#C4F538",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.2c93ec211f8d37d07376f5760d773c77.svg";
export { ForwardRef as ReactComponent };